<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12 col-md-6 q-pa-xs">
        <q-card flat bordered>
          <div class="row q-px-md q-pt-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">General Setup</h6>
            </div>
          </div>
          <div class="row q-pa-md">
            <div class="col-12 col-md-6 q-pa-xs">
              <q-input
                v-model="formData.event_name"
                label="Event Name (Auto Generated, Can edit after assigned a Discipline and Division)"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div
              class="col-12 col-sm-6 q-pa-xs"
              :class="{ 'col-md-3': competitionType == 'POOL' }"
            >
              <q-input
                label="Event No"
                v-model="formData.event_no"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div
              v-if="competitionType == 'POOL'"
              class="col-12 col-md-3 q-pa-xs"
            >
              <q-input
                v-model="formData.distance_m"
                label="Distance"
                @input="updateEventName"
                suffix="m"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div class="col-12 col-lg-6 q-pa-xs">
              <assignDivision
                :customData="divisions"
                :id="formData.division_id"
                @changed="updateDivision"
                required
              />
            </div>
            <div class="col-12 col-lg-6 q-pa-xs">
              <assignDiscipline
                :id="formData.discipline_id"
                @changed="updateDiscipline"
                required
              />
            </div>
          </div>
        </q-card>
      </div>

      <div class="col-12 col-md-6 q-pa-xs">
        <q-card flat bordered>
          <div class="row q-px-md q-pt-md">
            <div class="col-12">
              <h6 class="q-my-none q-mt-xs">Settings</h6>
            </div>
          </div>
          <div class="row q-pa-md">
            <div
              class="col-12 q-pa-xs"
              :class="{
                'col-lg-6':
                  currentDiscipline &&
                  JSON.parse(currentDiscipline.playerLabels).length > 1
              }"
            >
              <q-select
                v-model="formData.namingFormat"
                label="Naming Format"
                option-label="label"
                option-value="value"
                :emit-value="true"
                map-options
                :options="namingFormatsList"
                v-bind="siteCFG.fields.general"
              >
              </q-select>
            </div>
            <div
              v-if="
                currentDiscipline &&
                  JSON.parse(currentDiscipline.playerLabels).length > 1
              "
              class="col-12 col-lg-6 q-pa-xs"
            >
              <q-select
                v-model="formData.teamNamingFormat"
                label="Team Name Format"
                option-label="label"
                option-value="value"
                :emit-value="true"
                map-options
                :options="teamNamingFormatsList"
                v-bind="siteCFG.fields.general"
              >
              </q-select>
            </div>
            <div class="col-12 col-sm-6 q-pa-xs">
              <q-input
                v-model="formData.quotaPerAssociation"
                label="Quota (Per Association)"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div class="col-12 col-sm-6 q-pa-xs">
              <q-input
                v-model="formData.quotaMaxEntries"
                label="Quota (Max Entries)"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
              <q-input
                v-model="formData.num_lanes"
                label="Num Lanes"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div class="col-12 col-sm-6 col-md-3 q-pa-xs">
              <q-input
                v-model="formData.laneDrawOrder"
                label="Lane Draw Order"
                v-bind="siteCFG.fields.general"
              >
              </q-input>
            </div>
            <div class="col-12 col-md-6">
              <div class="row">
                <div class="col-12">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Require Team Captain"
                    v-model="formData.requireCaptain"
                  />
                </div>

                <div class="col-12">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Team Members can do more than 1 leg"
                    v-model="formData.moreThanOneLegAllowed"
                  />
                </div>
                <div class="col-12">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Change results page to Surf Teams format"
                    v-model="formData.teamsRaceEvent"
                  />
                </div>
                <div class="col-12">
                  <q-checkbox
                    :true-value="1"
                    :false-value="0"
                    dense
                    indeterminate-value="no-value"
                    label="Change results page to Reverse Placings"
                    v-model="formData.reversePlacings"
                  />
                </div>
              </div>
            </div>
          </div>
        </q-card>
      </div>
      <div class="col-12">
        <div
          v-if="currentDiscipline && currentDiscipline.playerLabels"
          class="row"
        >
          <div class="col-12">
            <h3 style="font-size: 22px" class="q-my-xs">Awards</h3>
          </div>
          <div
            class="col-12"
            v-for="(pl, index) in JSON.parse(currentDiscipline.playerLabels)"
            :key="`pl_${index}`"
          >
            <b>{{ pl.name }}</b> -{{
              pl.twoHundredMeter == 1 ? "200m Badge," : ""
            }}
            {{ pl.patrolSupport == 1 ? "PS or SLG," : "" }}
            {{ pl.slg == 1 ? "SLG Award," : "" }}
            {{ pl.crew == 1 ? "IRB Crew," : "" }}
            {{ pl.driver == 1 ? "IRB Driver," : "" }}
            {{ pl.mixed == 1 ? "Mixed Gender," : "" }}
            {{ pl.noMaxAge == 1 ? "Open Age," : "" }}
            {{ pl.required == 1 ? "Required" : "" }}
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";
import assignDiscipline from "@/components/disciplines/assignDiscipline.vue";
import assignDivision from "@/components/divisions/assignDivision.vue";

export default {
  components: { assignDivision, assignDiscipline },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
      siteCFG: "settings/siteCFG",
      data: "events/current",
      dataLoading: "events/currentLoading",
      disciplines: "disciplines/list",
      divisions: "divisions/list",
      eventSLGAwardList: "settings/eventSLGAwardList",
      namingFormatsList: "settings/namingFormatsList",
      teamNamingFormatsList: "settings/teamNamingFormatsList"
    }),
    currentDiscipline: function() {
      return this.disciplines.find(d => d.id == this.formData.discipline_id);
    }
  },
  props: {
    id: {
      default: null
    },
    competitionType: {
      default: "Beach",
      type: String
    }
  },
  watch: {
    data: function() {
      this.init();
    },
    id: function() {
      this.init();
    }
  },
  data: () => ({
    // Extra Data
    formData: {
      discipline_id: null,
      division_id: null,
      event_name: "",
      distance_m: 0,
      event_no: 0,
      team_size_min: 1,
      team_size_max: 1,
      namingFormat: null,
      fee: 0.0,
      lateFee: 0.0,
      num_lanes: null,
      laneDrawOrder: null,
      quotaPerAssociation: null,
      quotaMaxEntries: null,
      tags: null,
      requireCaptain: 0,
      individualEvent: 0,
      moreThanOneLegAllowed: 0,
      twoHundredMBadgeRequired: 0,
      slgAward: 3,
      enabled: 0,
      teamsRaceEvent: 0,
      reversePlacings: 0
    },
    tab: "general",

    impersonatingUser: false
  }),
  beforeCreate() {
    this.$store.dispatch("disciplines/loadAll");
    this.$store.dispatch("divisions/loadAll");
  },
  mounted() {
    this.init();
    if (this.id) {
      this.$store.dispatch("events/loadByID", this.id);
    }
  },
  methods: {
    init() {
      if (this.data && this.id && this.data.id == this.id) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        this.formData = {
          discipline_id: null,
          division_id: null,
          event_name: "",
          distance_m: 0,
          event_no: 0,
          team_size_min: 1,
          team_size_max: 1,
          namingFormat: 8,
          fee: 0.0,
          lateFee: 0.0,
          num_lanes: null,
          laneDrawOrder: null,
          quotaPerAssociation: null,
          quotaMaxEntries: null,
          tags: null,
          requireCaptain: 0,
          individualEvent: 0,
          moreThanOneLegAllowed: 0,
          twoHundredMBadgeRequired: 0,
          slgAward: 3,
          enabled: 0,
          teamsRaceEvent: 0,
          reversePlacings: 0
        };
      }
    },
    create() {
      this.$emit("loadingStateChanged", true);
      this.$refs.form.validate().then(result => {
        console.log(result);
        if (result) {
          this.$store.dispatch("events/new", this.formData).then(result => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.formData = {};
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: result.Response.Message
              });
            }
          });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);

      this.$store.dispatch("events/save", this.formData).then(result => {
        this.$emit("loadingStateChanged", false);
        if (result.Result == "Success") {
          this.$emit("close", true);
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: "User has been saved"
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later"
          });
        }
      });
    },
    addEventToCompetition(id) {
      let payload = this.formData;
      payload.competitions_id = id;
      this.$refs.form.validate().then(result => {
        console.log(result);
        if (result) {
          this.$emit("loadingStateChanged", true);

          this.$store
            .dispatch("events/addToCompetition", payload)
            .then(result => {
              this.$emit("loadingStateChanged", false);
              if (result.Result == "Success") {
                this.$emit("close", true);
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: result.Response.Message
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later"
                });
              }
            });
        }
      });
    },
    updateDivision(id) {
      this.formData.division_id = id;
      this.updateEventName();
    },
    updateDiscipline(id) {
      this.formData.discipline_id = id;
      this.updateEventName();
    },
    updateEventName() {
      let discipline = this.disciplines.find(
        d => d.id == this.formData.discipline_id
      );
      let division = this.divisions.find(
        d => d.id == this.formData.division_id
      );
      this.formData.event_name = `${
        division ? `${division.division_name} - ` : ""
      }${this.competitionType == "POOL" ? this.formData.distance_m + "m" : ""}${
        discipline ? ` ${discipline.discipline_name}` : ""
      }`;
    }
  }
};
</script>

<style lang="scss" scoped>
.formSubTitle {
  font-weight: bold;
}
</style>
